import {
    Component,
    ViewChild,
    OnInit,
    OnChanges,
    Output,
    EventEmitter,
} from "@angular/core";
import { RouterModule, Router, ActivatedRoute } from "@angular/router";
import { MatTable } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { first } from "rxjs/operators";
import { MatIconModule } from "@angular/material/icon";
import { TokenStorageService } from "app/main/auth/token-storage.service";
import {
    FormBuilder,
    FormGroup,
    FormControl,
    Validators,
} from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { MatDrawer } from "@angular/material/sidenav";
import * as d3 from "d3-selection";
import { SujetoObligadoService } from "app/main/services/sujeto-obligado.service";
import { SujetoObligado } from "app/main/models/sujeto-obligado.model";
import { ClientesService } from "app/main/services/clientes.service";
import { Cliente } from "app/main/models/cliente.model";
import { ClienteDialogBoxComponent } from "./cliente/dialog/dialog-box.component";
import { Location } from "@angular/common";
import { UserService } from "app/main/auth/user-mods.service";
import { UsersService } from "app/main/services/users.service";
import { RepresentanteDialogBoxComponent } from "./dialog/dialog-representante-box.component";
import { Usuario } from "app/main/models/usuario.model";
import { DebidaDiligenciaService } from "app/main/services/debida-diligencia.service";
import { PageEvent } from "@angular/material/paginator";
import { DialogBoxDebidaDiligenciaComponent } from "../dialog/dialog-box-debida-diligencia.component";
import { DebidaDiligencia } from "app/main/models/debida-diligencia.model";

const Parser = require("expr-eval").Parser;

@Component({
    selector: "sujeto-obligado-view",
    templateUrl: "./sujeto-obligado-view.component.html",
    styleUrls: ["./sujeto-obligado-view.component.scss"],
})
export class SujetoObligadoViewComponent implements OnInit, OnChanges {
    //Cart Date
    multi: any[];
    view: any[] = [700, 350];

    dataSource = [];
    dataSourceI = [];
    dataSourceR = [];
    resultsList = [];

    pieDataExposiciones = [];

    legend: boolean = true;
    showLabels: boolean = true;
    animations: boolean = true;
    xAxis: boolean = true;
    yAxis: boolean = true;
    showYAxisLabel: boolean = true;
    showXAxisLabel: boolean = true;
    xAxisLabel: string = "Probabilidad";
    yAxisLabel: string = "Impacto";
    gradient: boolean = false;

    colorScheme = {
        domain: ["#34C229", "#F1F80C", "#E44D25"],
    };

    customColors = [];
    customColorsPie = [];

    displayedColumnsClientes: string[] = [
        "tipo",
        "nombre",
        "razonSocial",
        "sectorIndustrial",
        "action",
    ];
    displayedColumnsRepresentantes: string[] = [
        "nombre",
        "correoElectronico",
        "action",
    ];
    displayedColumnsOperaciones: string[] = [
        "vencimiento",
        "cliente",
        "tipo",
        "estado",
        "beneficiario",
        "sectorIndustrial",
        "action",
    ];

    isEditable = false;
    isReseted = false;

    nombre: string = "";
    id: number = null;
    is_eval_creador: boolean = false;
    editar_nombre: boolean = false;
    editar_tipo: boolean = false;
    editar_razon_social: boolean = false;

    clientes: any = [];
    representates = [];
    debidasDiligencias: any = [];
    basicSlice = 10;

    sujetoObligado: SujetoObligado = null;

    filterForm: FormGroup;

    existeSujetoObligado: boolean = true;


    @ViewChild(MatTable, { static: true }) table: MatTable<any>;
    @ViewChild("tableAInherente", { static: true })
    tableAInherente: MatTable<any>;
    @ViewChild("stepper") private stepper: MatStepper;
    @Output() selectedTabChange: EventEmitter<MatTabChangeEvent>;

    //@ViewChild("stepper") stepper: MatStepper;

    constructor(
        public dialog: MatDialog,
        private storage: TokenStorageService,
        private service: SujetoObligadoService,
        private clienteService: ClientesService,
        private serviceDD: DebidaDiligenciaService,
        private _snackBar: MatSnackBar,
        public translate: TranslateService,
        private _formBuilder: FormBuilder,
        public router: Router,
        private location: Location,
        private usuarioService: UsersService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.route.paramMap.subscribe((params) => {
            this.id = parseInt(params.get("id"), 10);

            if (Number.isNaN(this.id)) {
                this.service
                    .getByRepresentante()
                    .pipe()
                    .subscribe((req) => {
                        if(req.body == null) {
                            this.existeSujetoObligado = false;
                        }else{
                            this.sujetoObligado = new SujetoObligado(req.body);
                            this.id = this.sujetoObligado.id;
                            var user = this.storage.getUser();
                            this.getClientes();
                            this.getDDPaginator(0);
                        }

                    });
            } else {
                this.service
                    .get(this.id)
                    .pipe()
                    .subscribe((req) => {
                        this.sujetoObligado = new SujetoObligado(req.body);
                        var user = this.storage.getUser();
                        this.getClientes();
                        this.getDDPaginator(0);
                    });
            }
        });

        this.filterForm = this._formBuilder.group({});
    }


    getClientes(): void {
        this.clienteService
            .getAllBySujetoObligado(this.id, 0, 1000)
            .pipe()
            .subscribe((req) => {
                this.clientes = req.body.map((so) => {
                    if (so.tipo == "PERSONA_FISICA")
                        return {
                            id: so.id,
                            tipo: so.tipo,
                            externalId: so.externalId,
                            nombre:
                                so.personaFisica?.nombre +
                                " " +
                                so.personaFisica?.apellido +
                                " " +
                                so.personaFisica?.segundoApellido,
                            razonSocial: so.personaFisica?.documentoIdentidad,
                            personaFisica: so.personaFisica,
                        };

                    if (so.tipo == "PERSONA_JURIDICA")
                        return {
                            id: so.id,
                            tipo: so.tipo,
                            externalId: so.externalId,
                            nombre: so.personaJuridica?.nombre,
                            razonSocial: so.personaJuridica?.razonSocial,
                            personaJuridica: so.personaJuridica,
                        };
                });

                this.clientes.sort((a, b) => (a.nombre > b.nombre ? 1 : -1));
            });
    }

    ngAfterViewChecked() {
        //this.actualizarColores();
    }

    ngOnChanges() {
        //this.actualizarColores();
    }

    navegateTo(url, id): void {
        this.router
            .navigate(["sujeto-obligado", this.id, "cliente", id])
            .then((e) => {
                if (e) {
                    console.log("Navigation is successful!");
                } else {
                    console.log("Navigation has failed!");
                }
            });
    }

    navegateToDD(url, uuid): void {
        this.router.navigate([url, uuid]).then((e) => {
            if (e) {
                console.log("Navigation is successful!");
            } else {
                console.log("Navigation has failed!");
            }
        });
    }

    back() {
        this.location.back();
    }

    print(): void {
        /*const dialogRef = this.dialog.open(DialogBoxPrintComponentEvaluacionConsolidadaDetallada, {
        width: '100%',
        data: {action:"Print", obj:{evaluacion:this.consolidacion,riesgos:this.riesgos}},
        autoFocus: false
      });
      */
    }

    getDDPaginator(page): void {
        this.serviceDD
            .getBySujetoObligado(this.id,this.filterForm, page, this.basicSlice)
            .pipe()
            .subscribe((req) => {
                this.debidasDiligencias = req.body.map((so) => {
                    return so;
                });
            });
    }

    openDialogClientes(action, obj): void {
        obj.sujetoObligado = this.sujetoObligado;
        obj.action = action;
        const dialogRef = this.dialog.open(ClienteDialogBoxComponent, {
            width: "100%",
            data: obj,
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.event === "Add") {
                this.addRowData(result.data);
            } else if (result.event === "Update") {
                this.updateRowData(result.data);
            } else if (result.event === "Delete") {
                this.deleteRowData(result.data);
            }
        });
    }

    addRowData(row_obj): void {
        console.log("Im here");
        this.clienteService
            .add(row_obj)
            .pipe(first())
            .subscribe(
                (data) => {
                    console.log(data);
                    this.openSnackBar(
                        "Se ingresó el cliente correctamente.",
                        "Cerrar"
                    );
                    this.getClientes();
                },
                (error) => {
                    console.log(error);
                    this.openSnackBar(
                        "No se pudo ingresar el cliente, ocurrió un error.",
                        "Cerrar"
                    );
                }
            );
    }

    updateRowData(row_obj): void {
        this.clienteService
            .edit(row_obj.id, row_obj)
            .pipe(first())
            .subscribe(
                (data) => {
                    console.log(data);
                    this.openSnackBar(
                        "Se actualizó el cliente correctamente.",
                        "Cerrar"
                    );
                    this.getClientes();
                    //Actualizar operaciones
                    this.getDDPaginator(0);
                },
                (error) => {
                    console.log(error);
                    this.openSnackBar(
                        "No se pudo actualizar el cliente, ocurrió un error.",
                        "Cerrar"
                    );
                }
            );
    }

    deleteRowData(row_obj): void {
        this.clienteService
            .delete(row_obj.id)
            .pipe(first())
            .subscribe(
                (data) => {
                    console.log(data);
                    this.clientes = this.clientes.filter((value, key) => {
                        return value.id !== row_obj.id;
                    });

                    this.openSnackBar(
                        "Se elimino el cliente correctamente.",
                        "Cerrar"
                    );
                    this.getDDPaginator(0);
                },
                (error) => {
                    console.log(error);
                    this.openSnackBar(
                        "No se pudo eliminar el cliente, esta asociado a otra entidad.",
                        "Cerrar"
                    );
                }
            );
    }

    openDialogRepresentantes(action, obj): void {
        obj.action = action;
        const dialogRef = this.dialog.open(RepresentanteDialogBoxComponent, {
            width: "100%",
            data: obj,
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.event === "Add") {
                this.addRowRepresentanteData(result.data);
            } else if (result.event === "Update") {
                this.updateRepresentanteRowData(result.data);
            } else if (result.event === "Delete") {
                this.deleteRepresentanteRowData(result.data);
            }
        });
    }

    addRowRepresentanteData(row_obj): void {
        console.log("Im here");
        this.service
            .addRepresentante(this.id, row_obj)
            .pipe(first())
            .subscribe(
                (data) => {
                    console.log(data);
                    this.openSnackBar(
                        "Se ingresó el representante correctamente.",
                        "Cerrar"
                    );
                    this.ngOnInit();
                    this.sujetoObligado.representantes.sort((a, b) =>
                        a.nombre > b.nombre ? 1 : -1
                    );
                },
                (error) => {
                    console.log(error);
                    this.openSnackBar(
                        "No se pudo ingresar el representante, ocurrió un error.",
                        "Cerrar"
                    );
                }
            );
    }

    updateRepresentanteRowData(row_obj): void {
        this.usuarioService
            .edit(row_obj.id, row_obj)
            .pipe(first())
            .subscribe(
                (data) => {
                    console.log(data);
                    this.sujetoObligado.representantes =
                        this.sujetoObligado.representantes.filter(
                            (value, key) => {}
                        );
                    //this.dataSource.sort((a, b) => (a.correoElectronico > b.correoElectronico) ? 1 : -1);
                    this.openSnackBar(
                        "Se actualizó el representante correctamente.",
                        "Cerrar"
                    );
                    this.ngOnInit();
                },
                (error) => {
                    console.log(error);
                    this.openSnackBar(
                        "No se pudo actualizar el representante, ocurrió un error.",
                        "Cerrar"
                    );
                }
            );
    }

    deleteRepresentanteRowData(row_obj): void {
        this.service
            .deleteRepresentante(this.id, row_obj.id)
            .pipe(first())
            .subscribe(
                (data) => {
                    console.log(data);
                    this.sujetoObligado.representantes =
                        this.sujetoObligado.representantes.filter(
                            (value, key) => {
                                return value.id !== row_obj.id;
                            }
                        );

                    this.openSnackBar(
                        "Se elimino el representante del sujeto obligado correctamente.",
                        "Cerrar"
                    );
                },
                (error) => {
                    console.log(error);
                    this.openSnackBar(
                        "No se pudo eliminar el representante del sujeto obligado, esta asociado a otra entidad.",
                        "Cerrar"
                    );
                }
            );
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 3000,
        });
    }

    delay(ms: number) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    compareObjects(o1: any, o2: any): boolean {
        return o1.nombre === o2.nombre && o1.id === o2.id;
    }

    esOwnersGroup(usuario): boolean {
        var esOwner: boolean = false;

        usuario.tipos.forEach((element) => {
            if (element.id == 4) esOwner = true;
        });

        return esOwner;
    }

    public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
        console.log(tabChangeEvent);
        console.log("Entro a tabChanged para actualizar los resultados");
        if (tabChangeEvent.tab.textLabel == "Análisis Residual") {
        }
        //this.calcularResultadosOriginal();
    }

    updateName(nombre): void {}

    openDialogDD(action, obj): void {
        obj.action = action;
        obj.clientes = this.clientes;
        obj.sujetoObligado = this.sujetoObligado;
        const dialogRef = this.dialog.open(DialogBoxDebidaDiligenciaComponent, {
            width: "100%",
            data: obj,
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result.event === "Add") {
                this.addDDRowData(result.data);
            } else if (result.event === "Update") {
                this.updateDDRowData(result.data);
            } else if (result.event === "Delete") {
                this.deleteDDRowData(result.data);
            }
        });
    }

    addDDRowData(row_obj): void {
        row_obj.sujetoObligado = { id: this.id };
        if (row_obj.cliente != null && row_obj.cliente.id != null)
            row_obj.cliente = { id: row_obj.cliente.id };

        this.serviceDD
            .register(row_obj)
            .pipe(first())
            .subscribe(
                (data) => {
                    console.log(data);
                    this.debidasDiligencias.push({
                        id: data.body.id,
                        uuid: data.body.uuid,
                        sujetoObligado: data.body.sujetoObligado,
                        cliente: data.body.cliente,
                        estado: data.body.estado,
                        tipoOperacion: data.body.tipoOperacion,
                        prioridad: data.body.prioridad,
                        beneficiarioPersonaJuridica:
                            data.body.beneficiarioPersonaJuridica,
                        beneficiarioPersonaFisica:
                            data.body.beneficiarioPersonaFisica,
                        sectorIndustrial: data.body.sectorIndustrial,
                        fechaVencimiento: data.body.fechaVencimiento,
                        moneda: data.body.moneda,
                        pais: data.body.pais,
                        monto: data.body.monto,
                        marcoDeReferencia: data.body.marcoDeReferencia,
                        ponderacionDeRiesgos: data.body.ponderacionDeRiesgos
                    });

                    this.openSnackBar(
                        "Se ingresó la operación correctamente.",
                        "Cerrar"
                    );
                    this.debidasDiligencias = [...this.debidasDiligencias];

                    this.getClientes();
                },
                (error) => {
                    console.log(error);
                    this.openSnackBar(
                        "No se pudo ingresar la operación, ocurrió un error.",
                        "Cerrar"
                    );
                }
            );
    }

    updateDDRowData(row_obj): void {
        this.serviceDD
            .edit(row_obj.id, row_obj)
            .pipe(first())
            .subscribe(
                (data) => {
                    console.log(data);
                    this.debidasDiligencias = this.debidasDiligencias.filter(
                        (value, key) => {
                            if (value.id === row_obj.id) {
                                value.id = row_obj.id;
                                value.uuid = row_obj.uuid;
                                value.sujetoObligado = row_obj.sujetoObligado;
                                value.cliente = row_obj.cliente;
                                value.estado = row_obj.estado;
                                value.tipoOperacion = row_obj.tipoOperacion;
                                value.prioridad = row_obj.prioridad;
                                value.beneficiarioPersonaJuridica =
                                    row_obj.beneficiarioPersonaJuridica;
                                value.beneficiarioPersonaFisica =
                                    row_obj.beneficiarioPersonaFisica;
                                value.sectorIndustrial =
                                    row_obj.sectorIndustrial;
                                value.fechaVencimiento =
                                    row_obj.fechaVencimiento;
                                value.ponderacionDeRiesgos = row_obj.ponderacionDeRiesgos;

                            }
                            return true;
                        }
                    );
                    //this.debidasDiligencias = [...this.debidasDiligencias];
                    this.openSnackBar(
                        "Se actualizó la operación correctamente.",
                        "Cerrar"
                    );
                },
                (error) => {
                    console.log(error);
                    this.openSnackBar(
                        "No se pudo actualizar la operación, ocurrió un error.",
                        "Cerrar"
                    );
                }
            );
    }

    deleteDDRowData(row_obj): void {
        this.serviceDD
            .delete(row_obj.id)
            .pipe(first())
            .subscribe(
                (data) => {
                    console.log(data);
                    this.debidasDiligencias = this.debidasDiligencias.filter(
                        (value, key) => {
                            return value.id !== row_obj.id;
                        }
                    );

                    this.openSnackBar(
                        "Se elimino la operación correctamente.",
                        "Cerrar"
                    );
                },
                (error) => {
                    console.log(error);
                    this.openSnackBar(
                        "No se pudo eliminar la operación, esta asociado a otra entidad.",
                        "Cerrar"
                    );
                }
            );
    }

    OnePageChange(event: PageEvent) {
        this.basicSlice = event.pageSize;
        this.getDDPaginator(event.pageIndex);
    }

    loadData():void{
        this.getDDPaginator(0);
    }
}
